import {
  cepNoMask,
  cpfCnpjNoMask,
  dateBRToDateISO,
  telephoneNoMask,
} from "../../functions/mask";

export const buildCustomerObject = async (
  customerForm: any,
  type: string,
  useWpp: boolean,
  inscEstadual: string,
  config: any,
  getOrderAddress: Function,
  customerValidationRegister?: boolean
) => {
  const orderAddressStorage = await getOrderAddress();
  
  const baseCustomer = {
    name: customerForm.name,
    email: customerForm.email,
    doc: cpfCnpjNoMask(customerForm.cpfOrCnpj),
    cpf: cpfCnpjNoMask(customerForm.cpfOrCnpj),
    optinWhatsapp: useWpp ? true : false,
    birthDate: customerForm.birthdate ? dateBRToDateISO(customerForm.birthdate) : null,
    gender: customerForm.gender,
    lgpdDataAceiteCarta: new Date(),
    password: "",
    inscEstadual: customerForm.inscEstadual,
    pluginconfigId: config?.content.pdv.pluginconfigId ? config?.content.pdv.pluginconfigId : 0,
  };

  // Adiciona validateRegister apenas se fornecido
  if (customerValidationRegister !== undefined) {
    (baseCustomer as any).validateRegister = customerValidationRegister;
  }

  const phones = [
    {
      typePhone: "cell",
      numberPhone: telephoneNoMask(customerForm.telephone),
    }
  ];

  const mainAddress = {
    zipCode: customerForm.cep ? cepNoMask(customerForm.cep) : "",
    street: customerForm.address,
    number: customerForm.number,
    district: customerForm.district,
    city: customerForm.city,
    state: customerForm.state,
    extra: customerForm.complement,
    reference: "",
    typeAddress: "main",
    ibge: customerForm.ibge,
  };

  if (type === "delivery") {
    phones.push({
      typePhone: "secondary",
      numberPhone: orderAddressStorage.telephone !== undefined
        ? telephoneNoMask(orderAddressStorage.telephone)
        : orderAddressStorage.telephone,
    });

    return {
      ...baseCustomer,
      phones,
      addresses: [
        mainAddress,
        {
          zipCode: orderAddressStorage.cep ? cepNoMask(orderAddressStorage.cep) : orderAddressStorage.cep,
          street: orderAddressStorage.address,
          number: orderAddressStorage.number,
          district: orderAddressStorage.district,
          city: orderAddressStorage.city,
          state: orderAddressStorage.state,
          extra: orderAddressStorage.complement,
          reference: "",
          typeAddress: "delivery",
          ibge: orderAddressStorage.ibge,
        }
      ]
    };
  }

  return {
    ...baseCustomer,
    phones,
    addresses: [mainAddress]
  };
};

export const buildCustomerFromResponse = (responseData: any, customerForm: any, useWpp: boolean, inscEstadual: string, customerValidationRegister?: boolean) => {
  const customer: any = {
    id: responseData.id ? responseData.id : responseData.dados?.id,
    name: customerForm.name,
    email: customerForm.email,
    cpf: customerForm.cpfOrCnpj,
    birthdate: customerForm.birthdate,
    wppNotification: useWpp,
    acceptTermDate: responseData.lgpdDataAceiteCarta ? responseData.lgpdDataAceiteCarta : responseData.dados?.lgpdDataAceiteCarta,
    gender: customerForm.gender,
    telephone: customerForm.telephone,
    cep: customerForm.cep,
    address: customerForm.address,
    district: customerForm.district,
    city: customerForm.city,
    state: customerForm.state,
    number: customerForm.number,
    complement: customerForm.complement,
    ibge: customerForm.ibge,
    inscEstadual,
  };

  if (customerValidationRegister !== undefined) {
    customer.validateRegister = customerValidationRegister;
  }

  if (responseData.customerId || responseData.dados?.customerId) {
    customer.customerWinthor = responseData.customerId || responseData.dados.customerId;
  }

  return customer;
};